import Resource from '@/services/resources/common';

export default class ContractPartnerResource extends Resource {
  constructor(entrypoint = '/contract_partners', alias = 'ContractPartner') {
    super(entrypoint, alias);
  }
}
